import _ from 'lodash';
import moment from 'moment-timezone';
import {
  getAlertsFilter,
  getVehiclesFilter,
  getRoutesFilter,
  getHandledByFilter,
  getRangeFilter,
  getStatusFilter,
  getBusinessFilter,
} from 'utils/filters';
import { FEATURES, IS_TENANT } from 'tenant/config';
import { COLLECTION, DISTRIBUTION } from '../shipper-orders/utils';

const businessTenant = (filter) => {
  const distributionFilter = filter === DISTRIBUTION ? { only_distributions: true } : {};
  const collectionFilter = filter === COLLECTION ? { only_collections: true } : {};
  return { ...distributionFilter, ...collectionFilter };
};
/**
 * @param {array} data
 * @param {string} groupingField
 * @returns {Object} - {2019-03-14: Array(13), 2019-03-15...}
 */
export const groupJourneyData = (data, { groupingField }) => {
  const groupedData = _.groupBy(data, (journey) => {
    const field = moment(journey[groupingField] || '').tz(journey.start_time_from_tz);
    return field.format('YYYY-MM-DD');
  });
  const dates = Object.keys(groupedData);

  return dates.reduce((acc, currV) => {
    acc[currV] = [...new Set(groupedData[currV].map((i) => i.id))];
    return acc;
  }, {});
};

/**
 * @param {array} statuses
 * @returns {string}
 */
export const mapStatuses = (statuses) => statuses.map((status) => 'status=' + status).join('&');

/**
 * @param {array} statuses
 * @returns {bool}
 */
export const isNotInActiveJobs = ({ statuses }) =>
  !statuses || statuses.length === 0 || statuses.includes('DONE');

/**
 * @param {object} filters
 * @returns {object}
 */
export const mapFiltersForBackend = (filters) => {
  const {
    handled_by,
    carrier,
    driver,
    date,
    page_size = 15,
    routes,
    shipper,
    municipality,
    sortingField,
    dateField,
    range_date,
    page,
    vehicle_type,
    alerts,
    prio,
    business,
    xDock,
    ftb,
  } = filters;

  const shipperFilter = shipper ? shipper.id : undefined;
  const driverFilter = driver ? driver.id : undefined;
  const carrierFilter = carrier ? carrier.id : undefined;
  const handledByFilter = getHandledByFilter(handled_by);
  const statusFilter = getStatusFilter(filters);
  const cityFilter = municipality ? municipality.value : undefined;
  const range_filter = getRangeFilter(range_date, dateField);
  const hasRangeFilter = Object.keys(range_filter).length > 0;
  const alertsFilter = getAlertsFilter(alerts);
  const routesFilter = getRoutesFilter(routes, FEATURES.IS_LH_FILTER_ENABLED);
  const vehiclesFilter = getVehiclesFilter(vehicle_type);
  const prioFilter = prio ? String(prio) : undefined;
  const businessFilter = IS_TENANT ? businessTenant(business) : getBusinessFilter(business);

  return {
    ...(!hasRangeFilter ? { [dateField]: date } : {}),
    ordering: sortingField,
    page_size,
    shipper: shipperFilter,
    driver: driverFilter,
    carrier: carrierFilter,
    handled_by: handledByFilter,
    statuses: statusFilter,
    municipality: cityFilter,
    page: page || undefined,
    shipper_is_prio: prioFilter,
    xdock: xDock ?? undefined,
    shipper_is_ftb: ftb,
    ...businessFilter,
    ...range_filter,
    ...alertsFilter,
    ...routesFilter,
    ...vehiclesFilter,
  };
};
